import { useCallback, type WheelEvent } from 'react';
import { type Point, toPoint } from './toPortInfo.tsx';
import { add } from './percentageOfLine.tsx';
import { useLatest } from './useLatest.tsx';
import { getZoomFromDeltaY } from './getZoomFromDeltaY.tsx';

export interface Options {
	pan: Point;
	zoom: number;
	updateZoom: (zoom: number) => void;
	updatePan: (pan: Point) => void;
}

export const useOnWheel = ({ pan, zoom, updateZoom, updatePan }: Options) => {
	const latestPan = useLatest(pan);
	return useCallback(
		(e: WheelEvent) => {
			e.preventDefault();
			// Mac style zoom, two finger = pan, pinch to zoom
			const shouldZoom = e.ctrlKey;
			const shouldPan = !shouldZoom;

			if (shouldZoom) {
				updateZoom(getZoomFromDeltaY(e.deltaY, zoom));
			} else if (shouldPan) {
				if (!e.target) {
					return;
				}

				updatePan(add(latestPan.current, toPoint(e.deltaX, e.deltaY)));
			}
		},
		[latestPan, updatePan, updateZoom, zoom],
	);
};

export default useOnWheel;
